import { css } from '@emotion/css';

export const footerButtonStyles = css`
  min-width: 0rem;
`;
